import { Component, Input, OnInit } from '@angular/core'
import { Dictionary } from '../../../../types/dictionary.type';
import { TableActionService } from '../../../custom-table/services/table-action.service';
import { ComponentConfiguration } from '../../models/component-config.model';
import { BookOrderActionViewComponent } from '../book-order-action-view/book-order-action-view.component';

export type OrderActionsItems = 'bookOrder'
  | 'suggestTerms'
  | 'cancelOrder'
  | 'deleteOrder'
  | 'viewDispatches'
  ;

@Component({
  selector: 'app-order-actions-common-view',
  templateUrl: './order-actions-common-view.component.html',
  styleUrls: ['./order-actions-common-view.component.scss'],
})
export class OrderActionsCommonViewComponent implements OnInit {
  @Input() model?: unknown;
  @Input() config: Dictionary<OrderActionsItems, OrderActionsModel> = {};
  items: OrderActionsModel[] = [];

  constructor(private readonly tableActionService: TableActionService) {
  }

  getConfig = (config: Dictionary<OrderActionsItems, OrderActionsModel>) => ({
    bookOrder: {
      config: {
        color: "accent",
        nameBtn: "Book",
        isComponent: true,
        componentConfig: {
          componentType:  BookOrderActionViewComponent,
        },
        isDisplayed: false,
        ...(config.bookOrder && config.bookOrder.config || {}),
      },
    },
    suggestTerms: {
      config: {
        color: "accent",
        nameBtn: "Counteroffer",
        isDisplayed: false,
        ...(config.suggestTerms && config.suggestTerms.config || {}),
      },
    },
    cancelOrder: {
      config: {
        color: "none",
        nameBtn: "Cancel",
        isDisplayed: false,
        ...(config.cancelOrder && config.cancelOrder.config || {}),
      },
    },
    deleteOrder: {
      config: {
        color: "none",
        nameBtn: "Delete Order",
        isDisplayed: false,
        ...(config.deleteOrder && config.deleteOrder.config || {}),
      },
    },
    viewDispatches: {
      config: {
        color: "accent",
        nameBtn: "View All",
        isDisplayed: false,
        ...(config.viewDispatches && config.viewDispatches.config || {}),
      },
    },
  })

  ngOnInit() {
    this.config = this.getConfig(this.config);
    this.setValue('bookOrder', this.model);
    this.items = Object.values(this.config).filter(x => x.config.isDisplayed);
  }

  click(action: OrderActionConfiguration) {
    action.click && action.click(this.model, this.tableActionService);
  }

  private setValue(item: OrderActionsItems, value: unknown) {
    const model = this.config[item];
    model.value = value;
  }
}

export class OrderActionsModel {
  value?: unknown;
  config: OrderActionConfiguration;
}

class OrderActionConfiguration {
  color: string;
  nameBtn: string;
  isDisplayed: boolean;
  isComponent?: boolean;
  componentConfig?: ComponentConfiguration;
  click?: (model: unknown, actionService: TableActionService) => void;
}

